import { render } from "./StatsComparator.vue?vue&type=template&id=57e1b158"
import script from "./StatsComparator.vue?vue&type=script&lang=js"
export * from "./StatsComparator.vue?vue&type=script&lang=js"
script.render = render

export default script